import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigateAndScroll } from "../Hooks/useNavigateAndScroll";

function DesktopNavbar({ navigate, handleNavigateAndScroll, goToExternalUrl }) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();
  const navigateAndScroll = useNavigateAndScroll();

  const isActive = (path) => location.pathname === path;
  const showDropdown = (key) => setActiveDropdown(key);
  const hideDropdown = () => setActiveDropdown(null);

  // Data-driven menu config (edit here, UI updates automatically)
  const menus = useMemo(
    () => [
      { key: "home", label: "Home", path: "/" },

      {
        key: "meetUs",
        label: "About Us",
        path: "/meet-us",
        items: [
          { label: "Mission Statement", onClick: () => handleNavigateAndScroll("/meet-us", "mission") },
          { label: "Our Providers", onClick: () => handleNavigateAndScroll("/meet-us", "providers") },
          { label: "Office Staff", onClick: () => handleNavigateAndScroll("/meet-us", "staff") },
          { label: "History", onClick: () => handleNavigateAndScroll("/meet-us", "history") },
        ],
      },

      {
        key: "services",
        label: "Services",
        path: "/services",
        items: [
          { label: "Expectant Parents", onClick: () => navigateAndScroll("/services/expectant-parents", "expectantParents") },
          { label: "Well Checks", onClick: () => navigateAndScroll("/services/well-checks", "wellChecks") },
          { label: "Same Day Sick Visits", onClick: () => navigateAndScroll("/services/same-day-sick-visits", "sameDaySickVisits") },
          { label: "Functional Medicine", onClick: () => navigateAndScroll("/services/functional-medicine", "functionalMedicine") },
          { label: "Common Medical Conditions", onClick: () => navigateAndScroll("/services/common-medical-conditions", "commonMedicalConditions") },
        ],
      },

      {
        key: "patientCenter",
        label: "Patient Center",
        path: "/patient-center",
        items: [
          { label: "New Patient Registration", onClick: () => navigateAndScroll("/patient-center/new-patient", "newPatient") },
          { label: "Patient Forms", onClick: () => navigateAndScroll("/patient-center/patient-forms", "patientForms") },
          { label: "Refill Requests", onClick: () => navigateAndScroll("/patient-center/refill-requests", "refillRequests") },
          { label: "Office Policy", onClick: () => navigateAndScroll("/patient-center/office-policies", "officePolicies") },
          { label: "FAQ's", onClick: () => navigateAndScroll("/patient-center/faqs", "faqs") },
        ],
      },

      {
        key: "contactUs",
        label: "Contact Us",
        path: "/contact-us",
        items: [
          { label: "Office Hours", onClick: () => handleNavigateAndScroll("/contact-us", "officeHours") },
          { label: "General Enquiries", onClick: () => handleNavigateAndScroll("/contact-us", "generalEnquiries") },
          // { label: "Schedule Appointment", onClick: () => goToExternalUrl("https://healow.com/...") },
          { label: "After-hours Urgent Advice", onClick: () => handleNavigateAndScroll("/contact-us", "afterHours") },
          { label: "Office Location", onClick: () => handleNavigateAndScroll("/contact-us", "officeLocation") },
        ],
      },
    ],
    [handleNavigateAndScroll, navigateAndScroll]
  );

  const activeItems = menus.find((m) => m.key === activeDropdown)?.items;

  const btnBase =
  "font-semibold p-1 px-2 transition-all duration-150 ease-out hover:bg-custom-blue hover:rounded-t hover:px-3";

  const btnActive = "bg-custom-blue rounded text-white";
  const btnHoverOnDropdown = "bg-custom-blue rounded-t";

  return (
    <nav className="bg-transparent py-1 px-4 flex w-full flex-col relative smartphone:hidden">
      {/* Top row */}
      <div className="flex justify-around w-full text-black text-sm">
        {menus.map((menu) => (
          <button
            key={menu.key}
            className={`${btnBase} ${isActive(menu.path) ? btnActive : ""} ${
              activeDropdown === menu.key ? btnHoverOnDropdown : ""
            }`}
            onMouseEnter={() => showDropdown(menu.key)}
            onMouseLeave={hideDropdown}
            onClick={() => navigate(menu.path)}
          >
            {menu.label}
          </button>
        ))}
      </div>

      {/* Full-width dropdown */}
      <div
        className={`absolute left-0 right-0 mt-[-4px] bg-custom-blue rounded-md text-white text-sm py-2 px-2 transition-all duration-300 ease-in-out z-50 ${
          activeItems ? "opacity-100" : "opacity-0 pointer-events-none"
        } overflow-hidden`}
        style={{ top: "100%" }}
        onMouseEnter={() => activeDropdown && showDropdown(activeDropdown)}
        onMouseLeave={hideDropdown}
      >
        {activeItems && (
          <div className="flex flex-wrap justify-around">
            {activeItems.map((item, idx) => (
              <a
                key={idx}
                className="p-2 cursor-pointer grow-text"
                onClick={() => {
                  item.onClick();
                  hideDropdown();
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}

export default DesktopNavbar;
